/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 535
// module chunks = 25